import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const Logo = ({ to = "/", className, testId = "brand-logo" }) => (
  <Link to={to} data-testid={testId} aria-label="Genesis Members Club home" className={cn("inline-flex shrink-0 items-center", className)}>
    <img src="/brand/genesis-logo.webp" alt="Genesis Members Club" width="520" height="284" className="logo-mark h-11 w-auto sm:h-12 lg:h-[58px]" />
  </Link>
);
